var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registrationTradeNo"},[_c('van-loading',{attrs:{"size":"12vw","text-size":"5vw","vertical":""}},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }